<template>
  <div class="parent">
    <vx-card ref="filterCard" title="Filters" class="user-list-filters mb-5">
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full mt-2">
          <label class="text-sm opacity-75">Device</label>
          <v-select
            :options="deviceList"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="filter.device"
            @search="searchDevice"
            class="mb-4 md:mb-0"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full mt-2">
          <label class="text-sm opacity-75">Filter</label>
          <v-select
            :options="dateList"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="filter.dateOption"
            class="mb-2 md:mb-0"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full mt-2">
          <label class="text-sm opacity-75">Start Time</label>
          <flat-pickr
            :disabled="disableDate"
            :config="{
              enableTime: true,
              dateFormat: 'Y-m-d H:i',
              maxDate: maxDate,
              time_24hr: true,
              defaultHour: 0
            }"
            style="width: 100%"
            v-model="filter.start_time"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full mt-2">
          <label class="text-sm opacity-75">End Time</label>
          <flat-pickr
            :disabled="disableDate"
            :config="{
              enableTime: true,
              dateFormat: 'Y-m-d H:i',
              maxDate: maxDate,
              time_24hr: true,
              defaultHour: 23,
              defaultMinute: 59
            }"
            style="width: 100%"
            v-model="filter.end_time"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full mt-2">
          <label class="text-sm opacity-75">Start Point</label>
          <v-select
            :options="PoiList"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="filter.start_poi"
            class="mb-3 md:mb-0"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full mt-2">
          <label class="text-sm opacity-75">End Point</label>
          <v-select
            :options="PoiList"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="filter.end_poi"
            class="mb-3 md:mb-0"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full mt-4">
          <vs-button
            id="searchBtn"
            style="width: 100%"
            color="success"
            type="filled"
            icon-pack="feather"
            icon="icon-search"
            class="pl-5 mt-1 vs-con-loading__container"
            @click="search"
            >Search</vs-button
          >
        </div>
      </div>
    </vx-card>

    <!-- List Journey Component -->
    <div class="list-journey">
      <b-card class="list-journey-card">
        <div class="flex flex-wrap items-center">
          <div class="flex-grow">
            <vs-button
              v-if="data.length > 0"
              id="exportBtn"
              icon-pack="feather"
              icon="icon-file-text"
              color="success"
              type="gradient"
              class="mb-4 md:mb-0 vs-con-loading__container"
              @click="handleDownload"
              >Export Data</vs-button
            >
          </div>

          <vs-dropdown vs-trigger-click class="cursor-pointer mr-2">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span class="mr-2"
                >{{ page * per_page - (per_page - 1) }} -
                {{
                  row_total - page * per_page > 0 ? page * per_page : row_total
                }}
                of {{ row_total }}</span
              >
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="updatePerPage(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="updatePerPage(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="updatePerPage(50)">
                <span>50</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="updatePerPage(100)">
                <span>100</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <div class="table-container">
          <table class="table table-bordered table-hover">
            <thead>
              <tr>
                <th scope="col" class="lj-head">RITASE</th>
                <th scope="col" class="lj-head">START POINT</th>
                <th scope="col" class="lj-head">END POINT</th>
                <th scope="col" class="lj-head">DURATION</th>
                <th scope="col" class="lj-head">MAP</th>
              </tr>
            </thead>
            <tbody class="table-body text-center">
              <tr v-for="(item, index) in data" :key="index" class="tr-body">
                <td style="width: 100px">
                  <el-tag class="tag" type="primary">
                    {{ item.status }}
                  </el-tag>
                </td>
                <td style="width: 500px">
                  <div class="timeline text-left">
                    <div class="timeline-wrapper">
                      <ul class="timeline-sessions">
                        <li class="session-1">
                          <template>
                            <div class="session-title text-muted">IN POI</div>
                            <span class="session-subtitle d-block">
                              {{ item.start_poi_name }}
                            </span>
                            <span class="session-time text-muted mt-1 d-block"
                              >{{ item.start_in_poi_time }}
                            </span>
                          </template>
                        </li>
                        <li class="session-2">
                          <template>
                            <div class="session-title text-muted">OUT POI</div>
                            <span class="session-subtitle d-block">
                              {{ item.start_poi_name }}
                            </span>
                            <span class="session-time text-muted mt-1 d-block"
                              >{{ item.start_out_poi_time }}
                            </span>
                          </template>
                        </li>
                      </ul>
                    </div>
                    <template>
                      <span style="text-align: justify">
                        {{ item.start_address }}
                      </span>
                    </template>
                  </div>
                </td>
                <td style="width: 500px">
                  <div class="timeline text-left">
                    <div class="timeline-wrapper">
                      <ul class="timeline-sessions">
                        <li class="session-1">
                          <template>
                            <div class="session-title text-muted">IN POI</div>
                            <span class="session-subtitle d-block">
                              {{ item.end_poi_name }}
                            </span>
                            <span class="session-time text-muted mt-1 d-block"
                              >{{ item.end_in_poi_time }}
                            </span>
                          </template>
                        </li>
                        <li class="session-2">
                          <template>
                            <div class="session-title text-muted">OUT POI</div>
                            <span class="session-subtitle d-block">
                              {{ item.end_poi_name }}
                            </span>
                            <span class="session-time text-muted mt-1 d-block"
                              >{{ item.end_out_poi_time }}
                            </span>
                          </template>
                        </li>
                      </ul>
                    </div>
                    <template>
                      <span style="text-align: justify">
                        {{ item.end_address }}
                      </span>
                    </template>
                  </div>
                </td>
                <td style="width: 150px">
                  <img
                    src="@/assets/images/tabler-icon/clock.svg"
                    class="mb-2"
                  />
                  <span class="d-block">
                    {{ item.total_time }}
                  </span>
                </td>
                <td style="width: 150px">
                  <div class="map-wrapper">
                    <a @click="toMap(item)">
                      <img
                        src="@/assets/images/tabler-icon/edited/map-pins-white.svg"
                        class="mb-2"
                      />
                      <span class="d-block">Lihat Map</span>
                    </a>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <div
            slot="append"
            v-if="data.length === 0 || loading"
            class="table_empty"
          >
            <b-skeleton-wrapper :loading="loading" class="mb-5">
              <!-- <template #loading>
                <div class="mb-5">
                  <b-skeleton
                    animation="fade"
                    class="mb-5"
                    width="85%"
                  ></b-skeleton>
                  <b-skeleton animation="fade" width="55%"></b-skeleton>
                  <b-skeleton animation="fade" width="70%"></b-skeleton>
                </div>
                <div class="mb-5">
                  <b-skeleton
                    animation="fade"
                    class="mb-5"
                    width="85%"
                  ></b-skeleton>
                  <b-skeleton animation="fade" width="55%"></b-skeleton>
                  <b-skeleton animation="fade" width="70%"></b-skeleton>
                </div>
                <div class="mb-5">
                  <b-skeleton
                    animation="fade"
                    class="mb-5"
                    width="85%"
                  ></b-skeleton>
                  <b-skeleton animation="fade" width="55%"></b-skeleton>
                  <b-skeleton animation="fade" width="70%"></b-skeleton>
                </div>
                <div class="mb-5">
                  <b-skeleton
                    animation="fade"
                    class="mb-5"
                    width="85%"
                  ></b-skeleton>
                  <b-skeleton animation="fade" width="55%"></b-skeleton>
                  <b-skeleton animation="fade" width="70%"></b-skeleton>
                </div>
                <div class="mb-5">
                  <b-skeleton
                    animation="fade"
                    class="mb-5"
                    width="85%"
                  ></b-skeleton>
                  <b-skeleton animation="fade" width="55%"></b-skeleton>
                  <b-skeleton animation="fade" width="70%"></b-skeleton>
                </div>
              </template> -->
            </b-skeleton-wrapper>
            {{ loading ? '' : 'No Data Available' }}
          </div>
        </div>

        <vs-pagination
          :total="n_page"
          v-model="page"
          class="mt-5"
        ></vs-pagination>
      </b-card>
    </div>
  </div>
</template>

<script>
import {
  BBreadcrumb,
  BBreadcrumbItem,
  BCard,
  BCardTitle,
  BCardText,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BFormDatepicker,
  BPagination
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    BBreadcrumb,
    BBreadcrumbItem,
    BCard,
    BCardTitle,
    BCardText,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    vSelect,
    BFormDatepicker,
    BPagination,
    flatPickr,
    VueApexCharts
  },

  directives: {
    Ripple
  },

  data() {
    return {
      data: [],
      token: '',
      deviceList: [],
      action: '',
      actor: '',
      PoiList: [],

      loading: false,
      loadingTime: 0,
      maxLoadingTime: 3,

      page: 1,
      per_page: 10,
      row_total: 0,
      keyword: '',

      filter: {
        device: '',
        start_time: null,
        end_time: null,
        start_poi: '',
        end_poi: '',
        today: '',
        dateOption: { value: '', label: '-- Select Filter --' }
      },

      filtered: {
        device: '',
        start_time: null,
        end_time: null,
        start_poi: '',
        end_poi: '',
        today: '',
        dateOption: { value: '', label: '-- Select Filter --' }
      },

      dateList: [
        { value: '', label: '-- Select Filter --' },
        { value: 'today', label: 'Today' },
        { value: 'yesterday', label: 'Yesterday' },
        { value: 'define', label: 'Select Date' }
      ],

      today: '',
      yesterday: '',
      twoDaysAgo: '',
      maxDate: '',
      disableDate: true,

      filename: 'Ritase Report',
      autoWidth: true,
      bookType: 'xlsx'
    }
  },

  computed: {
    n_page() {
      return Math.ceil(this.row_total / this.per_page)
    },

    dateOption() {
      return this.filter.dateOption ? this.filter.dateOption.value : ''
    }
  },

  watch: {
    page() {
      this.initTable()
    },

    per_page() {
      if (this.page != 1) this.page = 1
      else this.initTable()
    },

    dateOption() {
      let today = new Date()
      let yesterday = new Date(today)

      yesterday.setDate(yesterday.getDate() - 1)
      today = this.formatDate(today.toDateString())
      yesterday = this.formatDate(yesterday.toDateString())

      this.disableDate = true
      if (this.dateOption == 'today') {
        this.filter.start_time = this.today + ' 00:00'
        this.filter.end_time = this.today + ' 23:59'
        this.maxDate = this.today + ' 23:59'
      } else if (this.dateOption == 'yesterday') {
        this.filter.start_time = this.yesterday + ' 00:00'
        this.filter.end_time = this.yesterday + ' 23:59'
        this.maxDate = this.yesterday + ' 23:59'
      } else {
        this.filter.start_time = ''
        this.filter.end_time = ''
        this.maxDate = this.today + ' 23:59'
        // this.maxDate = this.twoDaysAgo + ' 23:59'
        this.disableDate = false
      }
    }

    // Test Loading
    // loading(newValue, oldValue) {
    //   if (newValue !== oldValue) {
    //     this.clearLoadingTimeInterval()

    //     if (newValue) {
    //       this.$_loadingTimeInterval = setInterval(() => {
    //         this.loadingTime++
    //       }, 1000)
    //     }
    //   }
    // },

    // loadingTime(newValue, oldValue) {
    //   if (newValue !== oldValue) {
    //     if (newValue === this.maxLoadingTime) {
    //       this.loading = false
    //     }
    //   }
    // }
  },

  created() {
    // this.$_loadingTimeInterval = null

    let today = new Date()
    let yesterday = new Date(today)
    let twoDaysAgo = new Date(today)

    yesterday.setDate(yesterday.getDate() - 1)
    twoDaysAgo.setDate(twoDaysAgo.getDate() - 2)

    this.today = this.formatDate(today.toDateString())
    this.yesterday = this.formatDate(yesterday.toDateString())
    this.twoDaysAgo = this.formatDate(twoDaysAgo.toDateString())

    this.token =
      localStorage.getItem('userInfo') !== null
        ? JSON.parse(localStorage.getItem('userInfo')).token
        : ''

    this.$http
      .get(`${this.$api.endpoint}/user/profile`, {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      })
      .then((res) => {
        this.actor = res.data.message.data
        this.searchDevice('')
        this.searchPoi('')
      })
      .catch((error) => {
        this.$gf.httpErrorHandler(error)
      })

    window.addEventListener('beforeunload', () => {
      localStorage.removeItem('ritaseData')
    })
  },

  beforeDestroy() {
    localStorage.removeItem('ritaseData')
  },

  // mounted() {
  //   this.startLoading()
  // },

  methods: {
    indexMethod(index) {
      return (this.page - 1) * this.per_page + (index + 1)
    },

    updatePerPage(n) {
      this.per_page = n
    },

    // clearLoadingTimeInterval() {
    //   clearInterval(this.$_loadingTimeInterval)
    //   this.$_loadingTimeInterval = null
    // },
    // startLoading() {
    //   this.loading = true
    //   this.loadingTime = 0
    // },

    formatDate(date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear()

      if (month.length < 2) month = '0' + month
      if (day.length < 2) day = '0' + day

      return [year, month, day].join('-')
    },

    searchDevice(keyword) {
      if (this.actor.privilege >= 4) {
        this.getDataDevice(keyword)
      } else {
        if (keyword.length >= 3) {
          this.getDataDevice(keyword)
        } else {
          this.deviceList = []
        }
      }
    },

    getDataDevice(keyword) {
      this.$http
        .get(
          `${this.$api.endpoint}/tracking/search?keyword=${keyword}&type=vehicle`,
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.deviceList = res.data.message.data
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    initTable() {
      this.data = []
      this.loading = true
      this.$http
        .get(`${this.$api.endpoint}/report/ritase_report`, {
          params: {
            page: this.page,
            per_page: this.per_page,
            device: this.filter.device ? this.filter.device.value : '',
            start: `${this.filter.start_time}:00`,
            end: `${this.filter.end_time}:00`,
            start_poi: this.filter.start_poi ? this.filter.start_poi.value : '',
            end_poi: this.filter.end_poi ? this.filter.end_poi.value : ''
          },

          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.loading = false
          this.$vs.loading.close(`#btn-cari > .con-vs-loading`)

          this.row_total = res.data.message.total
          this.data = res.data.message.data
          this.getAddress()
        })
        .catch((error) => {
          this.loading = false
          this.$vs.loading.close(`#btn-cari > .con-vs-loading`)
          this.$gf.httpErrorHandler(error)
        })
    },

    search() {
      this.loading = true
      // this.$vs.loading({
      //   background: 'success',
      //   color: '#fff',
      //   container: '#btn-cari',
      //   scale: 0.45
      // })

      // this.filtered.device = this.filter.device
      // this.filtered.start_time = this.filter.start_time
      // this.filtered.end_time = this.filter.end_time
      // this.filtered.start_time = this.filter.start_time
      // this.filtered.end_time = this.filter.end_time

      // this.page = 1
      this.initTable()
    },

    getAddress() {
      this.data.map((item, index) => {
        setTimeout(() => {
          this.$http
            .get(`${this.$api.base_url}/api/address`, {
              params: {
                latitude: item.start_lat,
                longitude: item.start_lon
              }
            })
            .then((res) => {
              this.data[index].start_address = res.data.message

              this.$http
                .get(`${this.$api.base_url}/api/address`, {
                  params: {
                    latitude: item.end_lat,
                    longitude: item.end_lon
                  }
                })
                .then((res) => {
                  this.data[index].end_address = res.data.message
                })
            })
        }, index * 300)
      })
    },

    getAddress2() {
      this.data.map((item, index) => {
        setTimeout(() => {
          this.$http
            .get(`${this.$api.base_url}/api/address`, {
              params: {
                latitude: item.detail_journey.lat,
                longitude: item.detail_journey.lon
              }
            })
            .then((res) => {
              this.data[index].address = res.data.message
            })
        }, index * 300)
      })
    },

    searchPoi(keyword) {
      if (this.actor.privilege >= 4) {
        this.getDataPoi(keyword)
      } else {
        if (keyword.length >= 3) {
          this.getDataPoi(keyword)
        } else {
          this.PoiList = []
        }
      }
    },

    getDataPoi(keyword) {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }

      this.timer = setTimeout(() => {
        this.$http
          .get(`${this.$api.endpoint}/poi/datatable`, {
            params: {
              page: 1,
              per_page: 50,
              search: keyword
            },

            headers: {
              Authorization: `Bearer ${this.token}`
            }
          })
          .then((res) => {
            this.PoiList = res.data.message.data
          })
          .catch((error) => {
            this.$gf.httpErrorHandler(error)
          })
      }, 1000)
    },

    toMap(item) {
      localStorage.setItem('ritaseData', JSON.stringify(item))
      let route = this.$router.resolve({ path: '/map-ritase' })
      window.open(route.href, '_blank')
    },

    handleDownload() {
      this.$vs.loading({
        background: 'success',
        color: '#fff',
        container: '#exportBtn',
        scale: 0.45
      })

      import('@/vendor/Export2Excel').then((excel) => {
        const tHeader = [
          'RITASE',
          'START POINT',
          'START POINT IN TIME',
          'START POINT OUT TIME',
          'END POINT',
          'END POINT IN TIME',
          'END POINT OUT TIME',
          'DURATION'
        ]
        const filterVal = [
          'status',
          'start_poi_name',
          'start_in_poi_time',
          'start_out_poi_time',
          'end_poi_name',
          'end_in_poi_time',
          'end_out_poi_time',
          'total_time'
        ]

        const list = this.data
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: this.filename,
          autoWidth: this.autoWidth,
          bookType: this.bookType
        })
        this.$vs.loading.close(`#exportBtn > .con-vs-loading`)
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          if (j === 'timestamp') {
            return parseTime(v[j])
          } else {
            return v[j]
          }
        })
      )
    }
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

.parent {
  font-family: 'Poppins';
}

.bc li.active {
  font-weight: 600;
  color: #1da1f2;
}

.date-input-card,
.list-journey-card,
.statistik-card {
  border: none;
  border-radius: 12px;
  box-shadow: 0px 2px 4px rgba(165, 163, 174, 0.3);
}

// Date Input CSS

.date-input .date-picker {
  background-color: white;
  cursor: pointer;
  min-height: 45px;
}

.date-input #btn-cari {
  background-color: #28c76f;
  border: none;
  border-radius: 6px;
  font-weight: 500;
}

.date-input #btn-cari:hover {
  box-shadow: 0px 2px 4px rgba(165, 163, 174, 0.3);
}

// List Journery CSS

.list-journey h4 {
  font-weight: 600;
}

.list-journey #btn-export {
  background-color: #f8f7fa;
  color: #1da1f2;
  border: 1px solid #1da1f2;
  border-radius: 4px;
  font-weight: 500;

  &::before {
    content: url('~@/assets/images/tabler-icon/edited/report-medical-blue.svg');
    margin-top: 6px;
    margin-right: 7px;
  }
}

.list-journey #btn-export:hover {
  background-color: #1da1f2;
  color: #f8f7fa;

  &::before {
    content: url('~@/assets/images/tabler-icon/edited/report-medical-white.svg');
    margin-top: 6px;
    margin-right: 7px;
  }
}

.list-journey .table-container tbody {
  color: #4b465c;
}

.list-journey .lj-head {
  background-color: #1da1f2;
  color: #fff;
  text-align: center;
  padding: 20px 18px;
  vertical-align: middle;
}

.list-journey td {
  vertical-align: middle;
  font-weight: 600;
  font-size: 15px;
}

.list-journey .tag {
  font-weight: 600;
  font-size: 13px;
}

.list-journey .map-wrapper {
  background-image: url(../.././assets/images/file-icons/map-bg.png);
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 4px;
  padding: 16px;
  color: #fff;
  font-style: italic;
  font-weight: 600;
}

.list-journey .map-wrapper a {
  color: #fff;
  font-style: italic;
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
}

// Timeline CSS Component
.timeline ul,
.timeline li {
  list-style: none;
  padding: 0;
}

.timeline .timeline-wrapper {
  padding: 10px;
}

.timeline .timeline-sessions {
  position: relative;
}

.timeline .session-title {
  font-weight: 400;
  font-size: 0.929rem;
}

.timeline .session-subtitle {
  font-weight: 600;
  font-size: 1.071rem;
}

.timeline .session-time {
  font-weight: 400;
  font-size: 0.929rem;
}

.timeline li.session-1 {
  padding-bottom: 1.5rem;
  border-left: 1px dashed #4b465c;
  position: relative;
  padding-left: 20px;
  margin-left: 10px;

  &:last-child {
    border: 0px;
    padding-bottom: 0;
  }

  &:before {
    content: '';
    width: 15px;
    height: 15px;
    background: #1da1f2;
    box-shadow: 0px 0px 0px 4px rgba(0, 209, 232, 0.2);
    border-radius: 50%;
    position: absolute;
    left: -8px;
    top: 0px;
  }
}

.timeline li.session-2 {
  padding-bottom: 1.5rem;
  border-left: 1px dashed #4b465c;
  position: relative;
  padding-left: 20px;
  margin-left: 10px;

  &:last-child {
    border: 0px;
    padding-bottom: 0;
  }

  &:before {
    content: '';
    width: 15px;
    height: 15px;
    background: #db4437;
    box-shadow: 0px 0px 0px 4px rgba(75, 70, 92, 0.1);
    border-radius: 50%;
    position: absolute;
    left: -8px;
    top: 0px;
  }
}

.timeline li.session-3 {
  padding-bottom: 1.5rem;
  border-left: 1px dashed #4b465c;
  position: relative;
  padding-left: 20px;
  margin-left: 10px;

  &:last-child {
    border: 0px;
    padding-bottom: 0;
  }

  &:before {
    content: '';
    width: 15px;
    height: 15px;
    background: linear-gradient(
        0deg,
        rgba(255, 255, 255, 0.1),
        rgba(255, 255, 255, 0.1)
      ),
      #4b465c;
    box-shadow: 0px 0px 0px 4px rgba(168, 170, 174, 0.3);
    border-radius: 50%;
    position: absolute;
    left: -8px;
    top: 0px;
  }
}

.timeline li.session-4 {
  padding-bottom: 1.5rem;
  border-left: 1px dashed #4b465c;
  position: relative;
  padding-left: 20px;
  margin-left: 10px;

  &:last-child {
    border: 0px;
    padding-bottom: 0;
  }

  &:before {
    // content: '';
    width: 15px;
    height: 15px;
    background: linear-gradient(
        0deg,
        rgba(255, 255, 255, 0.5),
        rgba(255, 255, 255, 0.5)
      ),
      #4b465c;
    box-shadow: 0px 0px 0px 4px rgba(75, 70, 92, 0.1);
    border-radius: 50%;
    position: absolute;
    left: -8px;
    top: 0px;
  }
}

.table_empty {
  text-align: center;
  font-size: 20px;
  padding: 10px;
  // border-left: 1px solid #ccc;
  // border-bottom: 1px solid #ccc;
  // width: 100%;
}

// Statistik CSS

.statistik {
  position: -webkit-sticky;
  position: sticky;
  top: 150px;
  overflow-y: auto;
  // height: 600px;
  height: 100%;
}

.statistik-title {
  font-weight: 600;
  font-size: 0.929rem;
}

.statistik-value {
  font-weight: 400;
  font-size: 0.929rem;
}

.statistik-subtitle {
  font-weight: 400;
  font-size: 0.814rem;
}

.statistik-card .gas-wrapper {
  background: rgba(255, 159, 67, 0.08);
  border-radius: 30px;
}
</style>
